// extracted by mini-css-extract-plugin
export var smallSpinner = "_qk-0";